var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/electricity_pricing.template.html');
var TimePicker = require('views/time_picker.view.ts');

var TheView = GenericView.extend({
    el: '#electricity',
    tagName: '',
	template: Handlebars.compile(Template),
	flatPricing: null,
	oldLat: null,
	oldLng: null,
	initialize: function (options) {
        this.render();
        var self = this;

        $(window).unbind("map:latLngChange").on("map:latLngChange", (event, latLng) => {
            var lat = latLng.lat;
            var lng = latLng.lng;

            var shouldLoadFlatPricing = (self.flatPricing == null && self.oldLat != lat && self.oldLng != lng) || (self.flatPricing != null && self.oldLat != lat && self.oldLng != lng)
            if (shouldLoadFlatPricing)
                self.loadFlatPricing(lat, lng);
        });

        GenericView.prototype.storeView(this, "electricity");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
        var time_picker_view = new TimePicker();
    },
    events: {
        "click input.check": "changeChecked",
        "click input[name=zones]": "checkAtLeastTwo",
        "input .to-validation input": "validateIt"
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    changeChecked: function(e) {
        $('.check').prop('checked', false);
        $(e.target).prop('checked', true);

        $("#electricity").find(".disabled").removeClass("disabled");

        var elements = $("#electricity").find("input.check:not(:checked)");
        $.each(elements, function(elem) {
            var currentField = $("#electricity").find("."+ $(this).attr("name"));

            if(!currentField.hasClass("disabled"))
                currentField.addClass("disabled");

        });
    },
    checkAtLeastTwo: function(e) {
        var checked = $("input[name=zones]:checked").length;
        if (checked < 2)
            $(e.target).prop('checked', true);
    },
    getAllData: function() {
        var data;
        if ( $(".flat").hasClass("disabled") ){
            data = this.getStaticPricingData();
        } else {
            data = {
                main_tar: this.convertToFloat("#main_tar_flat"),
                td_tar: this.convertToFloat("#t_d"),
                main_tax: this.convertToFloat("#main_tax_flat"),
                vat_tax: this.convertToFloat("#vat_tax_flat")
            };
        }

        return data;
    },
    getStaticPricingData: function(){
        var self = this;
        var static_pricing = {};

        var zones = $("input[name=zones]:checked");
        $.each(zones, function(index, value){
            var zone = $(this).val();
            static_pricing[zone] = {
                beginningTime: self.convertToInt($(this).parent().parent().parent().find(".beginning_time ." +zone +" select")),
                mainTariff: self.convertToFloat($(this).parent().parent().parent().find(".main_tariff ." +zone)),
                tdTariff: self.convertToFloat($(this).parent().parent().parent().find(".td ." +zone)),
                mainTaxLevie: self.convertToFloat($(this).parent().parent().parent().find(".main_taxies ." +zone)),
                vatRecoverableTaxLevie: self.convertToFloat($("#static_vat"))
            }
        });
        return static_pricing;
    },
    loadFlatPricing: function(lat, lng) {
        var self = this;

        this.lat_lng = "lat=" +lat+ "&lng=" +lng;
        $.ajax({
            url: "api/map/flatPricingCountry?"+self.lat_lng,
            type: "GET",
            contentType: "application/json"
        }).done(function(response) {
            self.oldLat = self.lat;
            self.oldLng = self.lng;

            var data = response.data;
            self.flatPricing = data;

            $("#main_tar_flat").val(data.productionTariff);
            $("#t_d").val(data.tdTariff);
            $("#main_tax_flat").val(data.taxDuties);
        }).fail(function(resp, xhr, errorMessage) {
            console.error("resp: ", resp);
            console.error("xhr: ", xhr);
            console.error("status: ", errorMessage);
        });
    }
});

module.exports= TheView;